import {
  SUBSCRIPTION_EXPIRED_SHOW_MODAL,
  SUBSCRIPTION_EXPIRED_HIDE_MODAL,
  IS_SUBSCRIPTION_EXPIRED,
  ASK_SHOW_SUBSCRIPTION_EXPIRED,
  SUBSCRIPTION_EXPIRED_SET_NEXT_ACTION,
  SUBSCRIPTION_EXPIRED_CLOSE_MODAL
} from './constants'

export function showSubscriptionExpiredModal () {
  return {
    type: SUBSCRIPTION_EXPIRED_SHOW_MODAL,
    payload: {}
  }
}

export function hideSubscriptionExpiredModal () {
  return {
    type: SUBSCRIPTION_EXPIRED_HIDE_MODAL,
    payload: {}
  }
}

export function isSubscriptionExpired (expired) {
  return {
    type: IS_SUBSCRIPTION_EXPIRED,
    payload: {expired}
  }
}

export function askShowSubscriptionExpired (nextActionExpired) {
  return {
    type: ASK_SHOW_SUBSCRIPTION_EXPIRED,
    payload: {nextActionExpired}
  }
}

export function setNextActionExpired (nextActionExpired) {
  return {
    type: SUBSCRIPTION_EXPIRED_SET_NEXT_ACTION,
    payload: {nextActionExpired}
  }
}

export function closeModal () {
  return {
    type: SUBSCRIPTION_EXPIRED_CLOSE_MODAL,
    payload: {}
  }
}



// WEBPACK FOOTER //
// ./app/actions/subscriptionExpired/index.js